export const ISUZU_CARE_FORM_ID = 'blt023d7ea5448cd43b';
export const TELETEC_FORM_ID = 'blt58dd470a0252e361';
export const COUPON_CAMPAIGN_ID = 'bltcb3ab736b3475295';
export const REGISTER_FORM_ID = 'blt42b30061afe833ae';
export const REGISTER_LCV_FORM_ID = 'bltdd79e9cd7892a91c';
export const TRUCK2HAND_FORM_ID = 'bltfecabc997145e892';
export const TIL_LOYALTY_CV_FORM_ID = 'bltc7e70c8ca1a6ee6d';
export const TIL_LOYALTY_LCV_FORM_ID = 'blt83728a67e03e27b4';

export const MAXFORCE_FORM_ID = 'prelaunch-maxforce';
